import * as React from 'react';
import { IgcMaskInputComponent as Component } from 'igniteui-webcomponents';
import type { IgcMaskInputComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * A masked input is an input field where a developer can control user input and format the visible value,
 * based on configurable rules
 * @slot prefix - Renders content before the input
 * @slot suffix - Renders content after the input
 * @slot helper-text - Renders content below the input
 * @slot value-missing - Renders content when the required validation fails.
 * @slot bad-input - Renders content when a required mask pattern validation fails.
 * @slot custom-error - Renders content when setCustomValidity(message) is set.
 * @slot invalid - Renders content when the component is in invalid state (validity.valid = false).
 * @fires igcInput - Emitted when the control receives user input
 * @fires igcChange - Emitted when an alteration of the control's value is committed by the user
 * @csspart container - The main wrapper that holds all main input elements
 * @csspart input - The native input element
 * @csspart label - The native label element
 * @csspart prefix - The prefix wrapper
 * @csspart suffix - The suffix wrapper
 * @csspart helper-text - The helper text wrapper
 * @class
 */
export const IgrMaskInput = /* @__PURE__ */ createComponent({
  tagName: 'igc-mask-input',
  displayName: 'IgrMaskInput',
  elementClass: Component,
  react: React,
  events: {
    onInput: 'igcInput' as EventName<IgcMaskInputComponentEventMap['igcInput']>,
    onChange: 'igcChange' as EventName<
      IgcMaskInputComponentEventMap['igcChange']
    >,
  },
});

export type IgrMaskInput = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrMaskInputModule = Component;
